import * as React from 'react'
import cx from 'classnames'
import * as styles from '../circle.tabs.styl'

export interface TabProps {
  selectorId?: string
  id?: number
  title?: string
  onClick?: (id: number) => void
  className?: string
  isActive?: boolean
  isCompleted?: boolean
}

const ItemCircleTab: React.FC<TabProps> = (props: TabProps) => {
  const { className, title, isActive, isCompleted, selectorId, onClick, id } =
    props
  function onClickTab() {
    if (typeof onClick === 'function') {
      onClick(id)
    }
  }

  return (
    <div className={styles.stepSwitch}>
      <div className={cx(styles.titleTab)}>{title}</div>
      <div
        id={selectorId}
        className={cx(styles.stepIcon, className, {
          [styles.selected]: isActive,
          [styles.incomplete]: !isCompleted,
          selected: isActive,
          incomplete: !isCompleted
        })}
        onClick={onClickTab}
      />
    </div>
  )
}

export default ItemCircleTab
